import { useActiveJob } from '../../hooks/active-job.hook';
import { JobChangeRequestTitle } from '../titles/ChangeRequestTitle';

export const JobChangeRequestNav = (): React.ReactElement<any, any> | null => {
    const { job } = useActiveJob();

    return <JobChangeRequestTitle job={job} />;
};
